// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*:root {*/
/*    !*senses*!*/
/*    --green: #257E74;*/
/*    --light-green: #3DB83D;*/
/*    !*  empty health  *!*/
/*    --blue: #4E59FA;*/
/*    --purple: #D84EFA*/
/*}*/

.select-plan-block-wrapper {
  width: 100%;
}

.select-plan-block-v2 .select-plan-container-v2 {
  box-sizing: border-box;
  min-width: 100%;
}

.select-plan-block-v2 .title, .select-plan-container-v2 .title {
  margin-bottom: 9px;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
}

.select-plan-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.select-plan-block-v2 .money-back-information {
  margin: 24px 0 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.8px;
  text-align: center;
}

.select-plan-block-v2 .button-container button {
  border-radius: 12px;
}

.select-plan-block-v2 .select-plan-container-v2 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.select-plan-block-v2 .plan-title {
  padding-left: 16px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;

  text-align: left;
}

.select-plan-block-v2 .plan-container-v2-wrapper {
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background-color: var(--light-gray2);
}

.select-plan-block-v2 .plan-container-v2-wrapper.selected {
  border: 1px solid var(--orange);
  background-color: var(--orange);
}

.select-plan-block-v2 .extra-top-container {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding: 6px 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.select-plan-block-v2 .plan-container-v2 {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  border-radius: 16px;
  padding: 16px;
  background-color: white;
  border: 1px solid transparent;
}

.select-plan-block-v2 .plan-container-v2-wrapper.selected .plan-container-v2 {
  border: 1px solid var(--orange);
}

.select-plan-block-v2 .extra-top {
  color: white;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.select-plan-block-v2 .left-info-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.select-plan-block-v2 .right-info-container {
  display: flex;
  gap: 4px;
  -webkit-box-align: center;
  align-items: center;
}

.select-plan-block-v2 .plan-name{
  color: var(--dark-gray3);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  white-space: nowrap;
}

.plan-container-v2-wrapper.selected .plan-name {
  color: var(--black);
}

.select-plan-block-v2 .tag-container {
  border-radius: 8px;
  padding: 4px 8px;
  background: var(--light-gray3);
  color: var(--dark-gray3);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  align-self: flex-start;
  width: fit-content;
}

.select-plan-block-v2 .plan-price {
  color: var(--dark-gray3);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.select-plan-block-v2 .crossed.red {
  position: relative;
}

.select-plan-block-v2 .crossed.red:before  {
  border-bottom: 1px solid red;
  position: absolute;
  content: "";
  width: 100%;
  height: 50%;
}

.select-plan-block-v2 .number, .select-plan-block-v2.currency {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  color: var(--dark-gray3);
}

.plan-container-v2-wrapper.selected .currency,
.plan-container-v2-wrapper.selected .integral-part,
.plan-container-v2-wrapper.selected .fractional-part {
  color: var(--black);
}

.select-plan-block-v2 .currency {
  margin-top: 2px;
  align-self: flex-start;
  align-items: flex-start;
  text-align: left;
}

.select-plan-block-v2 .plan-container-v2.with-extra .currency {
  margin-top: 2px;
}
.select-plan-block-v2 .plan-container-v2.with-tag .currency {
  margin-top: 19px;
}

.select-plan-block-v2 .integral-part {
  font-size: 48px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0;
  text-align: left;
}

.select-plan-block-v2 .column-container {
  display: flex;
  flex-direction: column;
}
.select-plan-block-v2 .period-label-container {
  gap: 4px;
}

.select-plan-block-v2 .plan-container-v2 .tag {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
}
.plan-container-v2-wrapper.selected .tag-container {
  background-color: var(--green-mint);
}
.plan-container-v2-wrapper.selected .tag {
  color: white;
}

.select-plan-block-v2 .crossed {
  text-decoration: line-through;
}

.select-plan-block-v2 .fractional-part {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
}

.select-plan-block-v2 .period-label {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.select-plan-v2.css"],"names":[],"mappings":"AAAA,UAAU;AACV,iBAAiB;AACjB,wBAAwB;AACxB,8BAA8B;AAC9B,2BAA2B;AAC3B,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/*:root {*/\n/*    !*senses*!*/\n/*    --green: #257E74;*/\n/*    --light-green: #3DB83D;*/\n/*    !*  empty health  *!*/\n/*    --blue: #4E59FA;*/\n/*    --purple: #D84EFA*/\n/*}*/\n\n.select-plan-block-wrapper {\n  width: 100%;\n}\n\n.select-plan-block-v2 .select-plan-container-v2 {\n  box-sizing: border-box;\n  min-width: 100%;\n}\n\n.select-plan-block-v2 .title, .select-plan-container-v2 .title {\n  margin-bottom: 9px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 29px;\n  text-align: center;\n}\n\n.select-plan-section {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.select-plan-block-v2 .money-back-information {\n  margin: 24px 0 12px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.8px;\n  text-align: center;\n}\n\n.select-plan-block-v2 .button-container button {\n  border-radius: 12px;\n}\n\n.select-plan-block-v2 .select-plan-container-v2 {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.select-plan-block-v2 .plan-title {\n  padding-left: 16px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n\n  text-align: left;\n}\n\n.select-plan-block-v2 .plan-container-v2-wrapper {\n  border: 1px solid transparent;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  background-color: var(--light-gray2);\n}\n\n.select-plan-block-v2 .plan-container-v2-wrapper.selected {\n  border: 1px solid var(--orange);\n  background-color: var(--orange);\n}\n\n.select-plan-block-v2 .extra-top-container {\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  padding: 6px 0;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.select-plan-block-v2 .plan-container-v2 {\n  display: flex;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  border-radius: 16px;\n  padding: 16px;\n  background-color: white;\n  border: 1px solid transparent;\n}\n\n.select-plan-block-v2 .plan-container-v2-wrapper.selected .plan-container-v2 {\n  border: 1px solid var(--orange);\n}\n\n.select-plan-block-v2 .extra-top {\n  color: white;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: uppercase;\n}\n\n.select-plan-block-v2 .left-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.select-plan-block-v2 .right-info-container {\n  display: flex;\n  gap: 4px;\n  -webkit-box-align: center;\n  align-items: center;\n}\n\n.select-plan-block-v2 .plan-name{\n  color: var(--dark-gray3);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 21px;\n  white-space: nowrap;\n}\n\n.plan-container-v2-wrapper.selected .plan-name {\n  color: var(--black);\n}\n\n.select-plan-block-v2 .tag-container {\n  border-radius: 8px;\n  padding: 4px 8px;\n  background: var(--light-gray3);\n  color: var(--dark-gray3);\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  align-self: flex-start;\n  width: fit-content;\n}\n\n.select-plan-block-v2 .plan-price {\n  color: var(--dark-gray3);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.select-plan-block-v2 .crossed.red {\n  position: relative;\n}\n\n.select-plan-block-v2 .crossed.red:before  {\n  border-bottom: 1px solid red;\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 50%;\n}\n\n.select-plan-block-v2 .number, .select-plan-block-v2.currency {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 21px;\n  color: var(--dark-gray3);\n}\n\n.plan-container-v2-wrapper.selected .currency,\n.plan-container-v2-wrapper.selected .integral-part,\n.plan-container-v2-wrapper.selected .fractional-part {\n  color: var(--black);\n}\n\n.select-plan-block-v2 .currency {\n  margin-top: 2px;\n  align-self: flex-start;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.select-plan-block-v2 .plan-container-v2.with-extra .currency {\n  margin-top: 2px;\n}\n.select-plan-block-v2 .plan-container-v2.with-tag .currency {\n  margin-top: 19px;\n}\n\n.select-plan-block-v2 .integral-part {\n  font-size: 48px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: 0;\n  text-align: left;\n}\n\n.select-plan-block-v2 .column-container {\n  display: flex;\n  flex-direction: column;\n}\n.select-plan-block-v2 .period-label-container {\n  gap: 4px;\n}\n\n.select-plan-block-v2 .plan-container-v2 .tag {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.plan-container-v2-wrapper.selected .tag-container {\n  background-color: var(--green-mint);\n}\n.plan-container-v2-wrapper.selected .tag {\n  color: white;\n}\n\n.select-plan-block-v2 .crossed {\n  text-decoration: line-through;\n}\n\n.select-plan-block-v2 .fractional-part {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 21px;\n  text-align: left;\n}\n\n.select-plan-block-v2 .period-label {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
